function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, MenuItem, TextField, Typography } from 'seagull';
import { requiredValidation } from 'validators';
import { routes } from "../../constants";
import { useOverlayContext, useIoContext } from "../../contexts";
import { handlePromise } from "../../infra/utils";
import { relationshipSummaryModel } from "../../models";
import { connectControllerToTextField } from "../../utils/react-hook-form.utils";
import { getClientViewURL } from "../unAuthorizedPages/LoginScreen";
import { compact } from 'lodash-es';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getAgreementLinks(relationship) {
  return compact([{
    id: 'home',
    text: 'Visit client portal',
    link: routes.home
  }, {
    id: 'agreement',
    text: 'View agreement',
    link: routes.agreement(relationship.id)
  }, !relationshipSummaryModel.isTerminated(relationship) && {
    id: 'pm',
    text: 'Manage payment methods',
    link: routes.paymentMethods(relationship.id)
  }, {
    id: 'team',
    text: 'Add team member',
    link: routes.team
  }, {
    id: 'business',
    text: 'Change company name',
    link: routes.businessDetails
  }, {
    id: 'profile',
    text: 'Change contact details',
    link: routes.profile
  }, {
    id: 'invoices',
    text: 'View invoices',
    link: routes.invoices(relationship.id)
  }, {
    id: 'activity',
    text: 'View activity log',
    link: routes.activityLog(relationship.id)
  }]);
}
export default function ShareAgreementLinksModal(_ref) {
  let {
    relationship,
    dismissModal
  } = _ref;
  const {
    control,
    handleSubmit
  } = useForm({
    mode: 'all',
    defaultValues: {
      pathname: ''
    }
  });
  const {
    copyToClipboard
  } = useIoContext();
  const {
    showErrorToast,
    showSuccessToast
  } = useOverlayContext();
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    textAlignCenter: false,
    title: "Share direct link",
    "data-testid": "direct-links-modal",
    content: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(Typography, {
        "data-testid": "direct-links-title",
        children: ["Invite", ' ', /*#__PURE__*/_jsx(Typography, {
          as: "span",
          weight: "bold",
          children: relationshipSummaryModel.customerBusinessName(relationship)
        }), ' ', "to:"]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Controller, {
        control: control,
        name: "pathname",
        rules: requiredValidation(),
        render: p => /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
          select: true,
          label: "Choose action",
          testid: "select-direct-link"
        }, connectControllerToTextField(p)), {}, {
          children: getAgreementLinks(relationship).map(_ref2 => {
            let {
              id,
              text,
              link
            } = _ref2;
            return /*#__PURE__*/_jsx(MenuItem, {
              value: getClientViewURL(link),
              "data-testid": "direct-link-".concat(id),
              children: text
            }, link);
          })
        }))
      })]
    }),
    primaryButtonLabel: "Copy link",
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: dismissModal,
    onPrimaryButtonClick: handleSubmit(async _ref3 => {
      let {
        pathname
      } = _ref3;
      const result = await handlePromise(copyToClipboard(window.location.origin + pathname));
      if (!result.success) {
        showErrorToast('Failed to copy link', 'copy-link-error');
      } else {
        showSuccessToast('Link was copied to clipboard', 'copy-link-success');
        dismissModal();
      }
    })
  });
}